import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const NewThreadHeading = (props) => (
  <Breadcrumb {...props}>
    <BreadcrumbItem href={LINKS.FORUM}>
      {placeholder('breadcrumbs.forum')}
    </BreadcrumbItem>
    <BreadcrumbItem>{placeholder('breadcrumbs.suggestThread')}</BreadcrumbItem>
  </Breadcrumb>
);

export default NewThreadHeading;
